import { DueDate } from './types';

export const overdueOrIn7Days = (
  dueDate: DueDate,
): { className: string; dueSoon: boolean } => {
  const ONE_DAY = 24 * 60 * 60 * 1000;
  let className = '';
  const isOverdue =
    dueDate?.text?.toLowerCase().includes('overdue') ||
    (dueDate.date !== null &&
      (new Date(dueDate.date).getTime() - Date.now()) / ONE_DAY < 0);
  const isDueIn7Days = dueDate.date
    ? (new Date(dueDate.date).getTime() - Date.now()) / ONE_DAY <= 7 &&
      (new Date(dueDate.date).getTime() - Date.now()) / ONE_DAY > 0
    : false;
  const dueSoon = isOverdue || isDueIn7Days;

  if (isOverdue) {
    className = 'theme--icon-overdue';
  }

  if (isDueIn7Days) {
    className = 'theme--icon-warning';
  }

  return { className, dueSoon };
};

export const getDueDateString = (
  dueDate: DueDate,
  isFrameworkMatched: boolean,
): string => {
  const date =
    // eslint-disable-next-line no-nested-ternary
    dueDate.date === null
      ? isFrameworkMatched
        ? ''
        : '-'
      : new Date(dueDate.date).toLocaleDateString('en-US');

  return date;
};

/**
 * Whether a due-date status text is the "expected to be patched" wording set by
 * nvmDataFetchCheckHandler's patching classification. Used to suppress that text
 * when the ys-expected-patches feature flag is off, since the underlying due date
 * is computed server-side with no per-user flag awareness.
 */
export const isExpectedPatchText = (text: string | null | undefined): boolean =>
  Boolean(text?.toLowerCase().includes('expected to be patched'));

/**
 * Mirrors yardstick-common-backend's getDaysUntilDue. Used as the fallback status
 * text when suppressing the "expected to be patched" wording (flag off), so the
 * finding still reads like a normal due date instead of showing nothing.
 */
export const getDaysUntilDueText = (date: DueDate['date']): string => {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return 'N/A';
  }
  const ONE_DAY = 24 * 60 * 60 * 1000;
  const daysDiff = Math.ceil((new Date(date).getTime() - Date.now()) / ONE_DAY);
  return daysDiff < 0
    ? `${Math.abs(daysDiff)} days overdue`
    : `${daysDiff} days until due`;
};
